export const FETCH_WORKLIST = "[GROUP_ADMIN] FETCH_WORKLIST";
export const FETCH_WORKLIST_START = "[GROUP_ADMIN] FETCH_WORKLIST_START";
export const FETCH_WORKLIST_SUCCESS = "[GROUP_ADMIN] FETCH_WORKLIST_SUCCESS";
export const FETCH_WORKLIST_ERROR = "[GROUP_ADMIN] FETCH_WORKLIST_ERROR";
export const SET_WORKLIST_PAGINATION = "[GROUP_ADMIN] SET_WORKLIST_PAGINATION";
export const SET_WORKLIST_FILTER = "[GROUP_ADMIN] SET_WORKLIST_FILTER";

export const SHOW_WORKLIST_MODAL = "[GROUP_ADMIN] SHOW_WORKLIST_MODAL";
export const HIDE_WORKLIST_MODAL = "[GROUP_ADMIN] HIDE_WORKLIST_MODAL";
export const UPDATE_STUDY = "[GROUP_ADMIN] UPDATE_STUDY";
export const UPDATE_STUDY_START = "[GROUP_ADMIN] UPDATE_STUDY_START";
export const UPDATE_STUDY_SUCCESS = "[GROUP_ADMIN] UPDATE_STUDY_SUCCESS";
export const UPDATE_STUDY_ERROR = "[GROUP_ADMIN] UPDATE_STUDY_ERROR";
export const RESET_WORKLIST_FILTER = "[GROUP_ADMIN] RESET_WORKLIST_FILTER";

export const fetchWorklist = (data) => {
    return {
        type: FETCH_WORKLIST,
        payload: data
    }
}

export const showWorklistModal = (selectedVisit) => {
    return {
        type: SHOW_WORKLIST_MODAL,
        selectedVisit
    };
};

export const updateStudy = (visit) => {
    return {
        type: UPDATE_STUDY,
        payload: visit
    };
};

export const closeWorklistModal = () => {
    return {
        type: HIDE_WORKLIST_MODAL
    };
};

export const resetWorklistFilter = () => {
    return {
        type: RESET_WORKLIST_FILTER,
    };
}